'use client';

import { useOverlayTriggerState } from '@react-stately/overlays';
import type { ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';

import { cn, Flex, Link, Spacing } from '@zoomit/primitives';
import { onMenuClick, OriginURL, UnauthorizedModal, useProfileInfo } from '@zoomit/web-kit';
import { Button } from '@zoomit/zoomit-ds';

import { useWebKitCustomization } from '../../../hooks/useWebKitCustomization';

type Props = {
  clearTriggeredMenuItem?: () => void;
  hasTransparentStyle?: boolean;
  icon?: ReactNode;
  as?: 'item' | 'subItem';
};

export const DefaultMenuProfile = (props: Props) => {
  const { clearTriggeredMenuItem, icon, hasTransparentStyle = false } = props;

  const { isAuthenticated, user } = useAuth();
  const unauthorizedModal = useOverlayTriggerState({});
  const tenantPersianTitle = useWebKitCustomization((state) => state.tenantPersianTitle);
  const basePath = useWebKitCustomization((state) => state.basePath);
  const urlBasePath = basePath ? OriginURL : '';

  const { data: profileData } = useProfileInfo({
    userId: user?.profile.sub as string,
    enabled: isAuthenticated && !!user?.profile.sub,
  });

  return isAuthenticated ? (
    <Link
      onPointerEnter={clearTriggeredMenuItem}
      href={
        profileData?.isAuthor
          ? `${urlBasePath}/author/${user?.profile.sub}`
          : `${urlBasePath}/profile/${user?.profile.sub}`
      }
      onClick={() => {
        onMenuClick({ menu: `${tenantPersianTitle} من`, device: 'desktop' });
      }}
      className="group"
    >
      <div
        className={cn(
          'text-body group-hover:text-primary2 [&_svg]:group-hover:fill-primary1 flex items-center gap-1 leading-loose font-black',
          hasTransparentStyle ? 'text-[#E8E2D8]' : 'text-text',
        )}
      >
        <Flex alignItems="center" flexWrap="nowrap" gap={Spacing.x}>
          {icon}
          {tenantPersianTitle} من
        </Flex>
      </div>
    </Link>
  ) : (
    <>
      <div
        className="group cursor-pointer"
        onPointerEnter={clearTriggeredMenuItem}
        onClick={() => unauthorizedModal.open()}
      >
        <div
          className={cn(
            'text-body group-hover:text-primary2 [&_svg]:group-hover:fill-primary1 flex items-center gap-1 leading-loose font-black',
            hasTransparentStyle ? 'text-[#E8E2D8]' : 'text-text',
          )}
        >
          {icon}
          {tenantPersianTitle} من
        </div>
      </div>
      <UnauthorizedModal isOpen={unauthorizedModal.isOpen} onClose={() => unauthorizedModal.close()} />
    </>
  );
};
